// extracted by mini-css-extract-plugin
module.exports = {"logoTitle":"navbar_logoTitle__cVSN5"};